module.exports = __webpack_public_path__ + "img/house.7324f6a2.svg";